"use strict";
import './csf-fournisseur-activities-list.scss';
import React, {useEffect, useState} from 'react';
import {createRoot} from 'react-dom/client';
import DrupalAccessTokenApi from "../../../js/csf/DrupalAccessTokenApi";
import {startLoadingSpinner, stopLoadingSpinner} from '../../csf-ufc-pivotal/includes/utils';
import PivotalSearchApi from "../../../js/csf/pivotal/PivotalSearchApi";
import CsfFournisseurActivitiesListTable from "./csf-fournisseur-activities-list-table";
import CsfFournisseurPagination from "../includes/csf-fournisseur-pagination";
import {buildSearchConditionsContains, getSortingQuery, handleClickLinks, clearSearchBtn} from '../includes/utils';
import PropTypes from "prop-types";

export function CsfPivotalFournisseurActivitiesList({apiUrl, apiEnv, urlDetailFormation, urlRequestRecognition}) {

  const [accessToken, setAccessToken] = useState('');
  const [formations, setFormations] = useState([]);
  const [inputSearchValue, setInputSearchValue] = useState('');
  const [startRow, setStartRow] = useState(1);
  const [total, setTotal] = useState(0);
  const [isSearch, setIsSearch] = useState(false);
  const [sorting, setSorting] = useState('');
  const [sortingDirection, setSortingDirection] = useState("desc");
  const [sortingTerm, setSortingTerm] = useState("descending");
  const [statusFilter, setStatusFilter] = useState([]);
  const offset = 5; // number of elements per page

  /*
  * On components mounts fetch the user access token only once.
  * */
  useEffect(() => {
    startLoadingSpinner();
    fetchAccessToken();
  }, []);

  /*
  * When the accessToken is fetched and state is updates, get the formations lists.
  * */
  useEffect(() => {
    if (accessToken) {
      startLoadingSpinner();
      getFormationsList();
      setIsSearch(false);
    }
  }, [accessToken, startRow, isSearch, sorting, sortingDirection, statusFilter]);

  /*
  * Init the bootstrap tooltips on list change
  * */
  useEffect(() => {
    if (formations) {
      $('[data-toggle="tooltip"]').tooltip({
        customClass: 'sup-tooltip'
      });
    }
  }, [formations]);

  /*
  * Method to call drupal api to get the access token of the session.
  * */
  function fetchAccessToken() {
    const drupalAccessTokenApi = new DrupalAccessTokenApi();
    drupalAccessTokenApi.fetchPostRequest('fournisseur')
      .then(response => {
        if (response?.api_access_token) {
          setAccessToken(response.api_access_token);
        } else {
          stopLoadingSpinner();
        }
      })
      .catch(error => {
        stopLoadingSpinner();
        console.error(error);
      });
  }

  /*
  * Method to fetch the formations lists of the users.
  * */
  function getFormationsList() {
    const requestData = buildMainBodyDataResquest();
    const pivotalSearchApi = new PivotalSearchApi(apiUrl, apiEnv, accessToken);
    pivotalSearchApi.callSearchEndpoint(requestData, '_Espace_Partenaire')
      .then(response => {
        if (response?.success && response?.payload?.data?.rows?.length >= 0) {
          setFormations(response.payload.data.rows); // get only the last 5 on the homepage
          setTotal(response.payload.data.searchTotal);
          stopLoadingSpinner();
        }
      })
      .catch(error => {
        stopLoadingSpinner();
        console.error(error);
      });
  }


  // Recoit l'event onChange du filtre select multi-valeurs en en-tete de liste
  //  le value des options est le Status_Name_French
  // voir: CsfFournisseurActivitiesListTable
  function handleStatusFilterChange(event) {
    const selectedOptions = Array.from(event.target.selectedOptions);
    const selectedValues = selectedOptions.map(option => option.value);
    // associe au filtre un array de string avec les values selectionnees
    setStartRow(1);
    setStatusFilter(selectedValues);
  }


  /*
  * Method to build the body array for the request
  * */
  function buildMainBodyDataResquest() {
    let requestData = {
      maxRows: offset,
      startRow: startRow,
      ParameterValues: [""],
      matchCondition: 1,
      search: 'CSF_EP_Activity_REST',
      searchResultsList: 'CSF_EP_Activity_SRL'
    };

    if(sorting !== ""){
      requestData.sort = getSortingQuery(sorting, sortingDirection);
    }

    // filtre select multi-valeurs en en-tete de liste
    //  le value des options est le Status_Name_French
    const statufFilterValues = [];
    for(const filterVal of statusFilter) {
      statufFilterValues.push({
        searchField: 'Status_Name_French',
        searchText: filterVal
      });
    }

    //Remove characters from the string, before sending it to pivotal.
    let filteredSearchValue = inputSearchValue.replace(/[#$]/g,"");

    let searchConditions = buildSearchConditionsContains(
      filteredSearchValue,
      // TODO Valider si on cherche toujours sur le status ou non avec les filtres ajoutes?
      ["Name_French", "Name_English", "Recognition_Code" /*, "Status_Name_French", "Status_Name_English"*/],
      statufFilterValues
    );

    if (searchConditions.length > 0) {
      requestData.conditions = searchConditions;
    }

    return requestData;
  }

  /*
  * Method that handle the value changed on the search bar.
  * */
  function handleSearchChange(event) {
    const value = event.target.value;
    setInputSearchValue(value);
  }

  /*
  * Method that handle the click on the search Btn of the search bar
  * */
  function handleSearchBtn(event){
    if (event.key === 'Enter' || event.type === "click") {
      setIsSearch(true);
      setStartRow(1);
    }
  }

  /*
  * Method that handle the click on the sorting titles
  * */
  function handleSortingClick(sortField, sortDirection) {
    setSorting(sortField);
    setSortingDirection(sortDirection); // desc ou asc
    setSortingTerm((sortDirection === 'asc' ? 'ascending' : 'descending'));

    // if (sortField === sorting) {
    //   setSortingDirection((prevDirection) => (prevDirection === 'desc' ? 'asc' : 'desc'));
    //   setSortingTerm((prevDirection) => (prevDirection === 'descending' ? 'ascending' : 'descending'));
    // } else {
    //   setSorting(sortField);
    //   setSortingDirection('desc');
    //   setSortingTerm('descending');
    // }
  }

  /*
  * Method that trigger an empty search when X button is clicked in the search field.
  * */
  function retriggerEmptySearch(){
    setInputSearchValue("");
    setIsSearch(true);
    setStartRow(1);
  }

  return (
    <main className="fournisseur fournisseur-activities-list">
      <div className="space-between-wrapper header-wrapper">
        <h1>{window.Drupal.t('fournisseur.activities-list.title')}</h1>
        <button className="button btn-with-icon btn-larger" onClick={() => handleClickLinks(urlRequestRecognition)}>
          <i className="icon icon-csf-plus"><span className="d-none">&nbsp;</span></i>
          {window.Drupal.t('fournisseur.activities-list.new-btn')}
        </button>
      </div>

      <div className="content smaller-wrapper">
        <div className="search-container">
          <label htmlFor="activityTableSearch" className="sr-only">{window.Drupal.t('search.label')}</label>
          <input type="search" id="activityTableSearch" value={inputSearchValue} onChange={handleSearchChange} onKeyDown={handleSearchBtn}
                  placeholder={window.Drupal.t('fournisseur.search.activities.placeholder')}/>
          <button className="search-close-icon btn-link" aria-label={window.Drupal.t('fournisseur.search.clear.label')}
            onClick={(e) => {
              clearSearchBtn(e, setInputSearchValue);
              retriggerEmptySearch();
            }}
          >
            <i className="icon icon-remove"></i>
          </button>
          <button className="button btn-outlined search-icon" onClick={handleSearchBtn}
                  title={window.Drupal.t('search.label')} aria-label={window.Drupal.t('search.label')}>
            <i className="icon icon-search-2"><span className="d-none">&nbsp;</span></i>
          </button>
        </div>

        <CsfFournisseurActivitiesListTable
          formations={formations}
          urlDetailFormation={urlDetailFormation}
          handleSortingClick={handleSortingClick}
          sortingDirection={sortingDirection}
          sortingTerm={sortingTerm}
          sorting={sorting}
          handleStatusFilterChange={handleStatusFilterChange}
        />

        <div className="pagination-wrapper smaller-wrapper">
          <CsfFournisseurPagination
            startRow={startRow}
            offset={offset}
            total={total}
            setStartRowFunction={setStartRow}
          />
        </div>
      </div>
    </main>
  );
}

window.addEventListener('DOMContentLoaded', () => {
  const domNode = document.getElementById('CsfPivotalFournisseurActivitiesList');
  if (domNode !== null) {
    const root = createRoot(domNode);

    const apiUrl = domNode.getAttribute("data-api-url");
    const apiEnv = domNode.getAttribute("data-api-env");
    const urlDetailFormation = domNode.getAttribute("data-url-detail");
    const urlRequestRecognition = domNode.getAttribute("data-url-request-recognition");

    root.render(<CsfPivotalFournisseurActivitiesList
      apiUrl={apiUrl}
      apiEnv={apiEnv}
      urlDetailFormation={urlDetailFormation}
      urlRequestRecognition={urlRequestRecognition}
    />);
  }
});

CsfPivotalFournisseurActivitiesList.propTypes = {
  apiUrl: PropTypes.string,
  apiEnv: PropTypes.string,
  urlDetailFormation: PropTypes.string,
  urlRequestRecognition: PropTypes.string
};
